import type { FC } from "react";

import FlyersCarousel from "@/src/homepage/Flyers/FlyersCarousel";

import type { IRoundList } from "../../common/RoundList";
import type { IFlyerSectionItem } from "./FlyerSectionItem";

export interface IFlyersSection {
    personalizedFlyers: IFlyerSectionItem[];
    roundTitleList?: IRoundList;
}

const FlyersSection: FC<IFlyersSection> = ({ personalizedFlyers }) => (
    <FlyersCarousel
        key={personalizedFlyers.length}
        items={personalizedFlyers}
        carouselTelemetryCustom={{
            eventName: "homepg-flyersArrowClick",
            actionType: "Click",
        }}
    />
);

export default FlyersSection;
